import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const CircularProgressDesignSettings = {
  'circular-progress-design-width': {
    phone: ['20px'],
    'phone-landscape': ['20px'],
    tablet: ['20px'],
    'tablet-landscape': ['20px'],
    desktop: ['10px'],
    tv: ['10px'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'circular-progress-design-typography': {
    phone: getDefaultTypography('Body Small'),
    'phone-landscape': getDefaultTypography('Body Small'),
    tablet: getDefaultTypography('Body Medium'),
    'tablet-landscape': getDefaultTypography('Body Medium'),
    desktop: getDefaultTypography('Body Large'),
    tv: getDefaultTypography('Body Large'),
  },
  'circular-progress-design-size': {
    phone: ['100px'],
    'phone-landscape': ['100px'],
    tablet: ['160px'],
    'tablet-landscape': ['170px'],
    desktop: ['120px'],
    tv: ['120px'],
  },
  'circular-progress-design-alignment': {
    phone: ['center'],
    'phone-landscape': ['center'],
    tablet: ['center'],
    'tablet-landscape': ['center'],
    desktop: ['center'],
    tv: ['center'],
  },
  'circular-progress-design-heading-alignment': {
    phone: ['center'],
    'phone-landscape': ['center'],
    tablet: ['center'],
    'tablet-landscape': ['center'],
    desktop: ['center'],
    tv: ['center'],
  },
  'circular-progress-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'circular-progress-design-heading-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'circular-progress-design-value-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'circular-progress-design-value-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'circular-progress-design-value-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'circular-progress-design-value-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'circular-progress-design-value-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },
}
